module.exports = __webpack_public_path__ + "static/img/tech3.7c22a03e.png";